import React from "react";
import Homepage from "../components/Homepage";

const Main = (props) => {
  return(
    <div className="container">
      <Homepage heading="Welcome to VINfo!" />
    </div>
  )
};

export default Main;